export default __webpack_public_path__ + "static/media/ic_rwanda.698677a4.svg";